import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import AdvertorialPage from "./components/AdvertorialPage";

// Sends a GA4 page_view on first load and every route change (deduped)
let lastTrackedPath = null;
function GAPageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === lastTrackedPath) return; // guard against duplicate fires (e.g. StrictMode)
    lastTrackedPath = path;
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GAPageViewTracker />
        <Routes>
          <Route path="/" element={<AdvertorialPage />} />
          <Route path="/the-market-is-rigged" element={<AdvertorialPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
